import React from 'react';

import {redirectForDownload} from 'BenchlingUtil';
import AsyncButton, {AsyncButtonLoadingBehavior} from 'ui-library/buttons/AsyncButton';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {InstrumentData, InstrumentFileStatus} from './InstrumentDataConstants';
import {getZipArchive} from './InstrumentDataDAO';

export interface GetFilesZipButtonProps {
  instrumentData: InstrumentData;
}

async function getFilesZip(instrumentData: InstrumentData): Promise<void> {
  const {downloadUrl} = await getZipArchive({
    searchFilter: instrumentData.filename,
    connectionFilter: [instrumentData.connectionId],
    connectionSchemaFilter: [],
    nextToken: '',
    fileTypeFilter: '',
    instrumentQueryFilter: [],
    transformDataTypeFilter: null,
  });
  redirectForDownload(downloadUrl);
}

export default function GetFilesZipButton(props: GetFilesZipButtonProps): JSX.Element {
  const isDisabled = [InstrumentFileStatus.NOT_UPLOADED, InstrumentFileStatus.ERRORED].includes(
    props.instrumentData.status
  );
  return (
    <Tooltip
      text={
        isDisabled
          ? 'Cannot download files until the file is retrieved.'
          : 'Download all original and transformed files created from this file.'
      }
    >
      <AsyncButton
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        loadingBehavior={AsyncButtonLoadingBehavior.SPINNER}
        size={ButtonSize.SMALL}
        onClick={async () => {
          await getFilesZip(props.instrumentData);
        }}
        text={<BenchlingIcon icon="download" />}
        disabled={isDisabled}
      />
    </Tooltip>
  );
}
